import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Seo } from '../components/Seo';
import { getCurrentUser } from '../utils/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    getCurrentUser()
      .then((user) => navigate('/admin', { replace: true, state: { user } }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) return <div className="min-h-screen bg-white" />;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" style={{ paddingTop: '200px', paddingBottom: '80px' }}>
      <Seo title="Agency Login | Kerry M Holloway Agency" description="Secure sign-in for Kerry M Holloway Agency staff." path="/admin/login" noindex />
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl shadow-sm p-10 text-center space-y-8" data-testid="admin-login-card">
        <div className="mx-auto w-14 h-14 rounded-full bg-[#D94B5A]/10 flex items-center justify-center">
          <Lock className="h-6 w-6 text-[#D94B5A]" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-[#1F1F1F]">Agency Dashboard</h1>
          <p className="text-sm text-gray-600">Sign in to view quote and contact requests.</p>
        </div>
        <Button onClick={handleLogin} data-testid="google-login-button" className="w-full bg-[#1F1F1F] hover:bg-gray-800 text-white py-6 text-base font-medium">
          <svg className="h-5 w-5 mr-3" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.8-5.5 3.8-3.3 0-6-2.7-6-6s2.7-6 6-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.8 3.3 14.6 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12s4.3 9.6 9.6 9.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z" />
          </svg>
          Sign in with Google
        </Button>
        <p className="text-xs text-gray-500">Access is limited to authorized agency staff.</p>
      </div>
    </div>
  );
};

export default AdminLogin;
